/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface MetricsService {
  /** @summary List Metric Metrics */
  listMetricMetricsExternalCallsMetricDefinitionsGet: {
    /** @summary List Metric Metrics */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
            ListMetricMetricsExternalCallsMetricDefinitionsGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<ListMetricMetricsExternalCallsMetricDefinitionsGetParameters, TMeta, TSignal>,
      client?: (
        schema: ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
        options: {
          parameters: ListMetricMetricsExternalCallsMetricDefinitionsGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          ListMetricMetricsExternalCallsMetricDefinitionsGetData,
          ListMetricMetricsExternalCallsMetricDefinitionsGetError
        >
      >
    ): Promise<
      RequestFnResponse<
        ListMetricMetricsExternalCallsMetricDefinitionsGetData,
        ListMetricMetricsExternalCallsMetricDefinitionsGetError
      >
    >;
    /** @summary List Metric Metrics */
    getQueryKey(
      parameters: DeepReadonly<ListMetricMetricsExternalCallsMetricDefinitionsGetParameters>
    ): ServiceOperationQueryKey<
      ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
      ListMetricMetricsExternalCallsMetricDefinitionsGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List Metric Metrics
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.metricsService.listMetricMetricsExternalCallsMetricDefinitionsGet.useQuery({
     *     query: {
     *         team_id: teamId
     *     }
     * })
     * ```
     */
    useQuery<TData = ListMetricMetricsExternalCallsMetricDefinitionsGetData>(
      parameters:
        | ServiceOperationQueryKey<
            ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
            ListMetricMetricsExternalCallsMetricDefinitionsGetParameters
          >
        | DeepReadonly<ListMetricMetricsExternalCallsMetricDefinitionsGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          ListMetricMetricsExternalCallsMetricDefinitionsGetData,
          ListMetricMetricsExternalCallsMetricDefinitionsGetError,
          TData,
          ServiceOperationQueryKey<
            ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
            ListMetricMetricsExternalCallsMetricDefinitionsGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<ListMetricMetricsExternalCallsMetricDefinitionsGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List Metric Metrics
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.metricsService.listMetricMetricsExternalCallsMetricDefinitionsGet.useQuery({
     *     query: {
     *         team_id: teamId
     *     }
     * })
     * ```
     */
    useQuery<TData = ListMetricMetricsExternalCallsMetricDefinitionsGetData>(
      parameters:
        | ServiceOperationQueryKey<
            ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
            ListMetricMetricsExternalCallsMetricDefinitionsGetParameters
          >
        | DeepReadonly<ListMetricMetricsExternalCallsMetricDefinitionsGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          ListMetricMetricsExternalCallsMetricDefinitionsGetData,
          ListMetricMetricsExternalCallsMetricDefinitionsGetError,
          TData,
          ServiceOperationQueryKey<
            ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
            ListMetricMetricsExternalCallsMetricDefinitionsGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<ListMetricMetricsExternalCallsMetricDefinitionsGetError>>;
    /** @summary List Metric Metrics */
    getInfiniteQueryKey(
      parameters: DeepReadonly<ListMetricMetricsExternalCallsMetricDefinitionsGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
      ListMetricMetricsExternalCallsMetricDefinitionsGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List Metric Metrics
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.metricsService.listMetricMetricsExternalCallsMetricDefinitionsGet.useInfiniteQuery({
     *     query: {
     *         team_id: teamId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             team_id: initialTeamId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListMetricMetricsExternalCallsMetricDefinitionsGetParameters,
      TQueryFnData = ListMetricMetricsExternalCallsMetricDefinitionsGetData,
      TData = OperationInfiniteData<TQueryFnData, ListMetricMetricsExternalCallsMetricDefinitionsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
            ListMetricMetricsExternalCallsMetricDefinitionsGetParameters
          >
        | DeepReadonly<ListMetricMetricsExternalCallsMetricDefinitionsGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListMetricMetricsExternalCallsMetricDefinitionsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
            ListMetricMetricsExternalCallsMetricDefinitionsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<ListMetricMetricsExternalCallsMetricDefinitionsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List Metric Metrics
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.metricsService.listMetricMetricsExternalCallsMetricDefinitionsGet.useInfiniteQuery({
     *     query: {
     *         team_id: teamId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             team_id: initialTeamId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListMetricMetricsExternalCallsMetricDefinitionsGetParameters,
      TQueryFnData = ListMetricMetricsExternalCallsMetricDefinitionsGetData,
      TData = OperationInfiniteData<TQueryFnData, ListMetricMetricsExternalCallsMetricDefinitionsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
            ListMetricMetricsExternalCallsMetricDefinitionsGetParameters
          >
        | DeepReadonly<ListMetricMetricsExternalCallsMetricDefinitionsGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListMetricMetricsExternalCallsMetricDefinitionsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
            ListMetricMetricsExternalCallsMetricDefinitionsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          ListMetricMetricsExternalCallsMetricDefinitionsGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<ListMetricMetricsExternalCallsMetricDefinitionsGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary List Metric Metrics
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const listMetricMetricsExternalCallsMetricDefinitionsGetTotal = qraft.metricsService.listMetricMetricsExternalCallsMetricDefinitionsGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const listMetricMetricsExternalCallsMetricDefinitionsGetByParametersTotal = qraft.metricsService.listMetricMetricsExternalCallsMetricDefinitionsGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             team_id: teamId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
            ListMetricMetricsExternalCallsMetricDefinitionsGetData,
            TInfinite,
            ListMetricMetricsExternalCallsMetricDefinitionsGetParameters,
            ListMetricMetricsExternalCallsMetricDefinitionsGetError
          >
        | QueryFiltersByQueryKey<
            ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
            ListMetricMetricsExternalCallsMetricDefinitionsGetData,
            TInfinite,
            ListMetricMetricsExternalCallsMetricDefinitionsGetParameters,
            ListMetricMetricsExternalCallsMetricDefinitionsGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary List Metric Metrics
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const listMetricMetricsExternalCallsMetricDefinitionsGetResults = qraft.metricsService.listMetricMetricsExternalCallsMetricDefinitionsGet.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 team_id: teamId1
     *             }
     *         },
     *         {
     *             query: {
     *                 team_id: teamId2
     *             }
     *         }
     *     ]
     * });
     * listMetricMetricsExternalCallsMetricDefinitionsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const listMetricMetricsExternalCallsMetricDefinitionsGetCombinedResults = qraft.metricsService.listMetricMetricsExternalCallsMetricDefinitionsGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 team_id: teamId1
     *             }
     *         },
     *         {
     *             query: {
     *                 team_id: teamId2
     *             }
     *         }
     *     ]
     * });
     * listMetricMetricsExternalCallsMetricDefinitionsGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
          ListMetricMetricsExternalCallsMetricDefinitionsGetParameters,
          ListMetricMetricsExternalCallsMetricDefinitionsGetData,
          ListMetricMetricsExternalCallsMetricDefinitionsGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<
          ListMetricMetricsExternalCallsMetricDefinitionsGetData,
          ListMetricMetricsExternalCallsMetricDefinitionsGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            ListMetricMetricsExternalCallsMetricDefinitionsGetData,
            ListMetricMetricsExternalCallsMetricDefinitionsGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary List Metric Metrics
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.metricsService.listMetricMetricsExternalCallsMetricDefinitionsGet.useSuspenseQuery({
     *     query: {
     *         team_id: teamId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = ListMetricMetricsExternalCallsMetricDefinitionsGetData>(
      parameters:
        | ServiceOperationQueryKey<
            ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
            ListMetricMetricsExternalCallsMetricDefinitionsGetParameters
          >
        | DeepReadonly<ListMetricMetricsExternalCallsMetricDefinitionsGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          ListMetricMetricsExternalCallsMetricDefinitionsGetData,
          ListMetricMetricsExternalCallsMetricDefinitionsGetError,
          TData,
          ServiceOperationQueryKey<
            ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
            ListMetricMetricsExternalCallsMetricDefinitionsGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<ListMetricMetricsExternalCallsMetricDefinitionsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary List Metric Metrics
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.metricsService.listMetricMetricsExternalCallsMetricDefinitionsGet.useSuspenseInfiniteQuery({
     *     query: {
     *         team_id: teamId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             team_id: initialTeamId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends ListMetricMetricsExternalCallsMetricDefinitionsGetParameters,
      TData = ListMetricMetricsExternalCallsMetricDefinitionsGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
            ListMetricMetricsExternalCallsMetricDefinitionsGetParameters
          >
        | DeepReadonly<ListMetricMetricsExternalCallsMetricDefinitionsGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          ListMetricMetricsExternalCallsMetricDefinitionsGetData,
          ListMetricMetricsExternalCallsMetricDefinitionsGetError,
          OperationInfiniteData<TData, ListMetricMetricsExternalCallsMetricDefinitionsGetParameters>,
          ServiceOperationInfiniteQueryKey<
            ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
            ListMetricMetricsExternalCallsMetricDefinitionsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          ListMetricMetricsExternalCallsMetricDefinitionsGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, ListMetricMetricsExternalCallsMetricDefinitionsGetParameters>,
      OperationError<ListMetricMetricsExternalCallsMetricDefinitionsGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary List Metric Metrics
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const listMetricMetricsExternalCallsMetricDefinitionsGetData = qraft.metricsService.listMetricMetricsExternalCallsMetricDefinitionsGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 team_id: teamId1
     *             }
     *         },
     *         {
     *             query: {
     *                 team_id: teamId2
     *             }
     *         }
     *     ]
     * });
     * listMetricMetricsExternalCallsMetricDefinitionsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const listMetricMetricsExternalCallsMetricDefinitionsGetCombinedData = qraft.metricsService.listMetricMetricsExternalCallsMetricDefinitionsGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 team_id: teamId1
     *             }
     *         },
     *         {
     *             query: {
     *                 team_id: teamId2
     *             }
     *         }
     *     ]
     * });
     * listMetricMetricsExternalCallsMetricDefinitionsGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
          ListMetricMetricsExternalCallsMetricDefinitionsGetParameters,
          ListMetricMetricsExternalCallsMetricDefinitionsGetData,
          ListMetricMetricsExternalCallsMetricDefinitionsGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          ListMetricMetricsExternalCallsMetricDefinitionsGetData,
          ListMetricMetricsExternalCallsMetricDefinitionsGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              ListMetricMetricsExternalCallsMetricDefinitionsGetData,
              ListMetricMetricsExternalCallsMetricDefinitionsGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary List Metric Metrics */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
        ListMetricMetricsExternalCallsMetricDefinitionsGetData,
        ListMetricMetricsExternalCallsMetricDefinitionsGetParameters,
        ListMetricMetricsExternalCallsMetricDefinitionsGetError
      >
    ): Promise<ListMetricMetricsExternalCallsMetricDefinitionsGetData>;
    /** @summary List Metric Metrics */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
        ListMetricMetricsExternalCallsMetricDefinitionsGetData,
        ListMetricMetricsExternalCallsMetricDefinitionsGetParameters,
        ListMetricMetricsExternalCallsMetricDefinitionsGetError
      >
    ): Promise<void>;
    /** @summary List Metric Metrics */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
        ListMetricMetricsExternalCallsMetricDefinitionsGetData,
        ListMetricMetricsExternalCallsMetricDefinitionsGetParameters,
        ListMetricMetricsExternalCallsMetricDefinitionsGetError
      >
    ): Promise<ListMetricMetricsExternalCallsMetricDefinitionsGetData>;
    /** @summary List Metric Metrics */
    fetchInfiniteQuery<TPageParam extends ListMetricMetricsExternalCallsMetricDefinitionsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
        ListMetricMetricsExternalCallsMetricDefinitionsGetData,
        ListMetricMetricsExternalCallsMetricDefinitionsGetParameters,
        DeepReadonly<TPageParam>,
        ListMetricMetricsExternalCallsMetricDefinitionsGetError
      >
    ): Promise<
      OperationInfiniteData<
        ListMetricMetricsExternalCallsMetricDefinitionsGetData,
        ListMetricMetricsExternalCallsMetricDefinitionsGetParameters
      >
    >;
    /** @summary List Metric Metrics */
    prefetchInfiniteQuery<TPageParam extends ListMetricMetricsExternalCallsMetricDefinitionsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
        ListMetricMetricsExternalCallsMetricDefinitionsGetData,
        ListMetricMetricsExternalCallsMetricDefinitionsGetParameters,
        DeepReadonly<TPageParam>,
        ListMetricMetricsExternalCallsMetricDefinitionsGetError
      >
    ): Promise<void>;
    /** @summary List Metric Metrics */
    ensureInfiniteQueryData<TPageParam extends ListMetricMetricsExternalCallsMetricDefinitionsGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
        ListMetricMetricsExternalCallsMetricDefinitionsGetData,
        ListMetricMetricsExternalCallsMetricDefinitionsGetParameters,
        DeepReadonly<TPageParam>,
        ListMetricMetricsExternalCallsMetricDefinitionsGetError
      >
    ): Promise<
      OperationInfiniteData<
        ListMetricMetricsExternalCallsMetricDefinitionsGetData,
        ListMetricMetricsExternalCallsMetricDefinitionsGetParameters
      >
    >;
    /** @summary List Metric Metrics */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
            ListMetricMetricsExternalCallsMetricDefinitionsGetParameters
          >
        | DeepReadonly<ListMetricMetricsExternalCallsMetricDefinitionsGetParameters>
    ): ListMetricMetricsExternalCallsMetricDefinitionsGetData | undefined;
    /** @summary List Metric Metrics */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
            ListMetricMetricsExternalCallsMetricDefinitionsGetParameters
          >
        | DeepReadonly<ListMetricMetricsExternalCallsMetricDefinitionsGetParameters>
    ):
      | OperationInfiniteData<
          ListMetricMetricsExternalCallsMetricDefinitionsGetData,
          ListMetricMetricsExternalCallsMetricDefinitionsGetParameters
        >
      | undefined;
    /** @summary List Metric Metrics */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
            ListMetricMetricsExternalCallsMetricDefinitionsGetData,
            TInfinite,
            ListMetricMetricsExternalCallsMetricDefinitionsGetParameters,
            ListMetricMetricsExternalCallsMetricDefinitionsGetError
          >
        | QueryFiltersByQueryKey<
            ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
            ListMetricMetricsExternalCallsMetricDefinitionsGetData,
            TInfinite,
            ListMetricMetricsExternalCallsMetricDefinitionsGetParameters,
            ListMetricMetricsExternalCallsMetricDefinitionsGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
              ListMetricMetricsExternalCallsMetricDefinitionsGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    ListMetricMetricsExternalCallsMetricDefinitionsGetData,
                    ListMetricMetricsExternalCallsMetricDefinitionsGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
              ListMetricMetricsExternalCallsMetricDefinitionsGetParameters
            >,
            data: ListMetricMetricsExternalCallsMetricDefinitionsGetData | undefined,
          ]
        >;
    /** @summary List Metric Metrics */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
            ListMetricMetricsExternalCallsMetricDefinitionsGetParameters
          >
        | DeepReadonly<ListMetricMetricsExternalCallsMetricDefinitionsGetParameters>
    ):
      | QueryState<
          ListMetricMetricsExternalCallsMetricDefinitionsGetData,
          ListMetricMetricsExternalCallsMetricDefinitionsGetError
        >
      | undefined;
    /** @summary List Metric Metrics */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<ListMetricMetricsExternalCallsMetricDefinitionsGetParameters>
        | ServiceOperationInfiniteQueryKey<
            ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
            ListMetricMetricsExternalCallsMetricDefinitionsGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            ListMetricMetricsExternalCallsMetricDefinitionsGetData,
            ListMetricMetricsExternalCallsMetricDefinitionsGetParameters
          >,
          ListMetricMetricsExternalCallsMetricDefinitionsGetError
        >
      | undefined;
    /** @summary List Metric Metrics */
    setQueryData(
      parameters:
        | DeepReadonly<ListMetricMetricsExternalCallsMetricDefinitionsGetParameters>
        | ServiceOperationQueryKey<
            ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
            ListMetricMetricsExternalCallsMetricDefinitionsGetParameters
          >,
      updater: Updater<
        NoInfer<ListMetricMetricsExternalCallsMetricDefinitionsGetData> | undefined,
        NoInfer<DeepReadonly<ListMetricMetricsExternalCallsMetricDefinitionsGetData>> | undefined
      >,
      options?: SetDataOptions
    ): ListMetricMetricsExternalCallsMetricDefinitionsGetData | undefined;
    /** @summary List Metric Metrics */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<ListMetricMetricsExternalCallsMetricDefinitionsGetParameters>
        | ServiceOperationInfiniteQueryKey<
            ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
            ListMetricMetricsExternalCallsMetricDefinitionsGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              ListMetricMetricsExternalCallsMetricDefinitionsGetData,
              ListMetricMetricsExternalCallsMetricDefinitionsGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                ListMetricMetricsExternalCallsMetricDefinitionsGetData,
                ListMetricMetricsExternalCallsMetricDefinitionsGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          ListMetricMetricsExternalCallsMetricDefinitionsGetData,
          ListMetricMetricsExternalCallsMetricDefinitionsGetParameters
        >
      | undefined;
    /** @summary List Metric Metrics */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
            ListMetricMetricsExternalCallsMetricDefinitionsGetData,
            TInfinite,
            ListMetricMetricsExternalCallsMetricDefinitionsGetParameters,
            ListMetricMetricsExternalCallsMetricDefinitionsGetError
          >
        | QueryFiltersByQueryKey<
            ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
            ListMetricMetricsExternalCallsMetricDefinitionsGetData,
            TInfinite,
            ListMetricMetricsExternalCallsMetricDefinitionsGetParameters,
            ListMetricMetricsExternalCallsMetricDefinitionsGetError
          >,
      updater: Updater<
        NoInfer<ListMetricMetricsExternalCallsMetricDefinitionsGetData> | undefined,
        NoInfer<ListMetricMetricsExternalCallsMetricDefinitionsGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<ListMetricMetricsExternalCallsMetricDefinitionsGetData | undefined>;
    /** @summary List Metric Metrics */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
        ListMetricMetricsExternalCallsMetricDefinitionsGetData,
        TInfinite,
        ListMetricMetricsExternalCallsMetricDefinitionsGetParameters,
        ListMetricMetricsExternalCallsMetricDefinitionsGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary List Metric Metrics */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
            ListMetricMetricsExternalCallsMetricDefinitionsGetData,
            TInfinite,
            ListMetricMetricsExternalCallsMetricDefinitionsGetParameters,
            ListMetricMetricsExternalCallsMetricDefinitionsGetError
          >
        | QueryFiltersByQueryKey<
            ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
            ListMetricMetricsExternalCallsMetricDefinitionsGetData,
            TInfinite,
            ListMetricMetricsExternalCallsMetricDefinitionsGetParameters,
            ListMetricMetricsExternalCallsMetricDefinitionsGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary List Metric Metrics */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
            ListMetricMetricsExternalCallsMetricDefinitionsGetData,
            TInfinite,
            ListMetricMetricsExternalCallsMetricDefinitionsGetParameters,
            ListMetricMetricsExternalCallsMetricDefinitionsGetError
          >
        | QueryFiltersByQueryKey<
            ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
            ListMetricMetricsExternalCallsMetricDefinitionsGetData,
            TInfinite,
            ListMetricMetricsExternalCallsMetricDefinitionsGetParameters,
            ListMetricMetricsExternalCallsMetricDefinitionsGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary List Metric Metrics */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
            ListMetricMetricsExternalCallsMetricDefinitionsGetData,
            TInfinite,
            ListMetricMetricsExternalCallsMetricDefinitionsGetParameters,
            ListMetricMetricsExternalCallsMetricDefinitionsGetError
          >
        | QueryFiltersByQueryKey<
            ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
            ListMetricMetricsExternalCallsMetricDefinitionsGetData,
            TInfinite,
            ListMetricMetricsExternalCallsMetricDefinitionsGetParameters,
            ListMetricMetricsExternalCallsMetricDefinitionsGetError
          >
    ): void;
    /** @summary List Metric Metrics */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
            ListMetricMetricsExternalCallsMetricDefinitionsGetData,
            TInfinite,
            ListMetricMetricsExternalCallsMetricDefinitionsGetParameters,
            ListMetricMetricsExternalCallsMetricDefinitionsGetError
          >
        | QueryFiltersByQueryKey<
            ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
            ListMetricMetricsExternalCallsMetricDefinitionsGetData,
            TInfinite,
            ListMetricMetricsExternalCallsMetricDefinitionsGetParameters,
            ListMetricMetricsExternalCallsMetricDefinitionsGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary List Metric Metrics */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
            ListMetricMetricsExternalCallsMetricDefinitionsGetData,
            TInfinite,
            ListMetricMetricsExternalCallsMetricDefinitionsGetParameters,
            ListMetricMetricsExternalCallsMetricDefinitionsGetError
          >
        | QueryFiltersByQueryKey<
            ListMetricMetricsExternalCallsMetricDefinitionsGetSchema,
            ListMetricMetricsExternalCallsMetricDefinitionsGetData,
            TInfinite,
            ListMetricMetricsExternalCallsMetricDefinitionsGetParameters,
            ListMetricMetricsExternalCallsMetricDefinitionsGetError
          >
    ): number;
    schema: ListMetricMetricsExternalCallsMetricDefinitionsGetSchema;
    types: {
      parameters: ListMetricMetricsExternalCallsMetricDefinitionsGetParameters;
      data: ListMetricMetricsExternalCallsMetricDefinitionsGetData;
      error: ListMetricMetricsExternalCallsMetricDefinitionsGetError;
    };
  };
  /** @summary Create */
  createExternalCallsMetricDefinitionsPost: {
    /** @summary Create */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        CreateExternalCallsMetricDefinitionsPostBody,
        CreateExternalCallsMetricDefinitionsPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: CreateExternalCallsMetricDefinitionsPostSchema,
        options: ServiceOperationMutationFnOptions<
          CreateExternalCallsMetricDefinitionsPostBody,
          CreateExternalCallsMetricDefinitionsPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<CreateExternalCallsMetricDefinitionsPostData, CreateExternalCallsMetricDefinitionsPostError>
      >
    ): Promise<
      RequestFnResponse<CreateExternalCallsMetricDefinitionsPostData, CreateExternalCallsMetricDefinitionsPostError>
    >;
    /** @summary Create */
    getMutationKey(
      parameters: DeepReadonly<CreateExternalCallsMetricDefinitionsPostParameters> | void
    ): ServiceOperationMutationKey<
      CreateExternalCallsMetricDefinitionsPostSchema,
      CreateExternalCallsMetricDefinitionsPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.metricsService.createExternalCallsMetricDefinitionsPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.metricsService.createExternalCallsMetricDefinitionsPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateExternalCallsMetricDefinitionsPostBody, TContext = unknown>(
      parameters: DeepReadonly<CreateExternalCallsMetricDefinitionsPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateExternalCallsMetricDefinitionsPostSchema,
        CreateExternalCallsMetricDefinitionsPostData,
        CreateExternalCallsMetricDefinitionsPostParameters,
        TVariables,
        OperationError<CreateExternalCallsMetricDefinitionsPostError>,
        TContext
      >
    ): UseMutationResult<
      CreateExternalCallsMetricDefinitionsPostData,
      OperationError<CreateExternalCallsMetricDefinitionsPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.metricsService.createExternalCallsMetricDefinitionsPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.metricsService.createExternalCallsMetricDefinitionsPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        CreateExternalCallsMetricDefinitionsPostBody,
        CreateExternalCallsMetricDefinitionsPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateExternalCallsMetricDefinitionsPostSchema,
        CreateExternalCallsMetricDefinitionsPostData,
        CreateExternalCallsMetricDefinitionsPostParameters,
        TVariables,
        OperationError<CreateExternalCallsMetricDefinitionsPostError>,
        TContext
      >
    ): UseMutationResult<
      CreateExternalCallsMetricDefinitionsPostData,
      OperationError<CreateExternalCallsMetricDefinitionsPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createExternalCallsMetricDefinitionsPostTotal = qraft.metricsService.createExternalCallsMetricDefinitionsPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createExternalCallsMetricDefinitionsPostTotal = qraft.metricsService.createExternalCallsMetricDefinitionsPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateExternalCallsMetricDefinitionsPostBody,
            CreateExternalCallsMetricDefinitionsPostData,
            CreateExternalCallsMetricDefinitionsPostParameters,
            OperationError<CreateExternalCallsMetricDefinitionsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateExternalCallsMetricDefinitionsPostSchema,
            CreateExternalCallsMetricDefinitionsPostBody,
            CreateExternalCallsMetricDefinitionsPostData,
            CreateExternalCallsMetricDefinitionsPostParameters,
            OperationError<CreateExternalCallsMetricDefinitionsPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createExternalCallsMetricDefinitionsPostPendingMutationVariables = qraft.metricsService.createExternalCallsMetricDefinitionsPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createExternalCallsMetricDefinitionsPostMutationData = qraft.metricsService.createExternalCallsMetricDefinitionsPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateExternalCallsMetricDefinitionsPostData,
        OperationError<CreateExternalCallsMetricDefinitionsPostError>,
        MutationVariables<
          CreateExternalCallsMetricDefinitionsPostBody,
          CreateExternalCallsMetricDefinitionsPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateExternalCallsMetricDefinitionsPostBody,
            CreateExternalCallsMetricDefinitionsPostData,
            CreateExternalCallsMetricDefinitionsPostParameters,
            OperationError<CreateExternalCallsMetricDefinitionsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateExternalCallsMetricDefinitionsPostSchema,
            CreateExternalCallsMetricDefinitionsPostBody,
            CreateExternalCallsMetricDefinitionsPostData,
            CreateExternalCallsMetricDefinitionsPostParameters,
            OperationError<CreateExternalCallsMetricDefinitionsPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateExternalCallsMetricDefinitionsPostData,
          OperationError<CreateExternalCallsMetricDefinitionsPostError>,
          MutationVariables<
            CreateExternalCallsMetricDefinitionsPostBody,
            CreateExternalCallsMetricDefinitionsPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Create */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateExternalCallsMetricDefinitionsPostBody,
            CreateExternalCallsMetricDefinitionsPostData,
            CreateExternalCallsMetricDefinitionsPostParameters,
            OperationError<CreateExternalCallsMetricDefinitionsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateExternalCallsMetricDefinitionsPostSchema,
            CreateExternalCallsMetricDefinitionsPostBody,
            CreateExternalCallsMetricDefinitionsPostData,
            CreateExternalCallsMetricDefinitionsPostParameters,
            OperationError<CreateExternalCallsMetricDefinitionsPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.metricsService.createExternalCallsMetricDefinitionsPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.metricsService.createExternalCallsMetricDefinitionsPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateExternalCallsMetricDefinitionsPostBody,
              CreateExternalCallsMetricDefinitionsPostData,
              CreateExternalCallsMetricDefinitionsPostParameters,
              OperationError<CreateExternalCallsMetricDefinitionsPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateExternalCallsMetricDefinitionsPostSchema,
              CreateExternalCallsMetricDefinitionsPostBody,
              CreateExternalCallsMetricDefinitionsPostData,
              CreateExternalCallsMetricDefinitionsPostParameters,
              OperationError<CreateExternalCallsMetricDefinitionsPostError>,
              TContext
            >
      ):
        | Mutation<
            CreateExternalCallsMetricDefinitionsPostData,
            CreateExternalCallsMetricDefinitionsPostError,
            MutationVariables<
              CreateExternalCallsMetricDefinitionsPostBody,
              CreateExternalCallsMetricDefinitionsPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateExternalCallsMetricDefinitionsPostBody,
              CreateExternalCallsMetricDefinitionsPostData,
              CreateExternalCallsMetricDefinitionsPostParameters,
              OperationError<CreateExternalCallsMetricDefinitionsPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateExternalCallsMetricDefinitionsPostSchema,
              CreateExternalCallsMetricDefinitionsPostBody,
              CreateExternalCallsMetricDefinitionsPostData,
              CreateExternalCallsMetricDefinitionsPostParameters,
              OperationError<CreateExternalCallsMetricDefinitionsPostError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateExternalCallsMetricDefinitionsPostData,
          CreateExternalCallsMetricDefinitionsPostError,
          MutationVariables<
            CreateExternalCallsMetricDefinitionsPostBody,
            CreateExternalCallsMetricDefinitionsPostParameters
          >,
          TContext
        >
      >;
    };
    schema: CreateExternalCallsMetricDefinitionsPostSchema;
    types: {
      parameters: CreateExternalCallsMetricDefinitionsPostParameters;
      data: CreateExternalCallsMetricDefinitionsPostData;
      error: CreateExternalCallsMetricDefinitionsPostError;
      body: CreateExternalCallsMetricDefinitionsPostBody;
    };
  };
  /** @summary Get Metric Definitions */
  getMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGet: {
    /** @summary Get Metric Definitions */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters,
            TMeta,
            TSignal
          >,
      client?: (
        schema: GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
        options: {
          parameters: GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
          GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError
        >
      >
    ): Promise<
      RequestFnResponse<
        GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
        GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError
      >
    >;
    /** @summary Get Metric Definitions */
    getQueryKey(
      parameters: DeepReadonly<GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters>
    ): ServiceOperationQueryKey<
      GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
      GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Metric Definitions
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.metricsService.getMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGet.useQuery({
     *     path: {
     *         definition_key: definitionKey
     *     },
     *     query: {
     *         team_id: teamId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters
          >
        | DeepReadonly<GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
          GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError,
          TData,
          ServiceOperationQueryKey<
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Metric Definitions
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.metricsService.getMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGet.useQuery({
     *     path: {
     *         definition_key: definitionKey
     *     },
     *     query: {
     *         team_id: teamId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters
          >
        | DeepReadonly<GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
          GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError,
          TData,
          ServiceOperationQueryKey<
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<
      TData,
      OperationError<GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError>
    >;
    /** @summary Get Metric Definitions */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
      GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Metric Definitions
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.metricsService.getMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGet.useInfiniteQuery({
     *     path: {
     *         definition_key: definitionKey
     *     },
     *     query: {
     *         team_id: teamId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             team_id: initialTeamId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters,
      TQueryFnData = GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
      TData = OperationInfiniteData<
        TQueryFnData,
        GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters
      >,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters
          >
        | DeepReadonly<GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<
      TData,
      OperationError<GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError>
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Metric Definitions
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.metricsService.getMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGet.useInfiniteQuery({
     *     path: {
     *         definition_key: definitionKey
     *     },
     *     query: {
     *         team_id: teamId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             team_id: initialTeamId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters,
      TQueryFnData = GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
      TData = OperationInfiniteData<
        TQueryFnData,
        GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters
      >,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters
          >
        | DeepReadonly<GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<
      TData,
      OperationError<GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError>
    >;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Metric Definitions
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetTotal = qraft.metricsService.getMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetByParametersTotal = qraft.metricsService.getMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             definition_key: definitionKey
     *         },
     *         query: {
     *             team_id: teamId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
            TInfinite,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError
          >
        | QueryFiltersByQueryKey<
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
            TInfinite,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Metric Definitions
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetResults = qraft.metricsService.getMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 definition_key: definitionKey1
     *             },
     *             query: {
     *                 team_id: teamId1
     *             }
     *         },
     *         {
     *             path: {
     *                 definition_key: definitionKey2
     *             },
     *             query: {
     *                 team_id: teamId2
     *             }
     *         }
     *     ]
     * });
     * getMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetCombinedResults = qraft.metricsService.getMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 definition_key: definitionKey1
     *             },
     *             query: {
     *                 team_id: teamId1
     *             }
     *         },
     *         {
     *             path: {
     *                 definition_key: definitionKey2
     *             },
     *             query: {
     *                 team_id: teamId2
     *             }
     *         }
     *     ]
     * });
     * getMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
          GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters,
          GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
          GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<
          GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
          GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Metric Definitions
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.metricsService.getMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGet.useSuspenseQuery({
     *     path: {
     *         definition_key: definitionKey
     *     },
     *     query: {
     *         team_id: teamId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters
          >
        | DeepReadonly<GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
          GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError,
          TData,
          ServiceOperationQueryKey<
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<
      TData,
      OperationError<GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError>
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Metric Definitions
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.metricsService.getMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGet.useSuspenseInfiniteQuery({
     *     path: {
     *         definition_key: definitionKey
     *     },
     *     query: {
     *         team_id: teamId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             team_id: initialTeamId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters,
      TData = GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters
          >
        | DeepReadonly<GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
          GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError,
          OperationInfiniteData<TData, GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters>,
      OperationError<GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Metric Definitions
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData = qraft.metricsService.getMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 definition_key: definitionKey1
     *             },
     *             query: {
     *                 team_id: teamId1
     *             }
     *         },
     *         {
     *             path: {
     *                 definition_key: definitionKey2
     *             },
     *             query: {
     *                 team_id: teamId2
     *             }
     *         }
     *     ]
     * });
     * getMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetCombinedData = qraft.metricsService.getMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 definition_key: definitionKey1
     *             },
     *             query: {
     *                 team_id: teamId1
     *             }
     *         },
     *         {
     *             path: {
     *                 definition_key: definitionKey2
     *             },
     *             query: {
     *                 team_id: teamId2
     *             }
     *         }
     *     ]
     * });
     * getMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
          GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters,
          GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
          GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
          GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
              GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Get Metric Definitions */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
        GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
        GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters,
        GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError
      >
    ): Promise<GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData>;
    /** @summary Get Metric Definitions */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
        GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
        GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters,
        GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError
      >
    ): Promise<void>;
    /** @summary Get Metric Definitions */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
        GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
        GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters,
        GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError
      >
    ): Promise<GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData>;
    /** @summary Get Metric Definitions */
    fetchInfiniteQuery<TPageParam extends GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
        GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
        GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters,
        DeepReadonly<TPageParam>,
        GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
        GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters
      >
    >;
    /** @summary Get Metric Definitions */
    prefetchInfiniteQuery<
      TPageParam extends GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters,
    >(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
        GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
        GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters,
        DeepReadonly<TPageParam>,
        GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError
      >
    ): Promise<void>;
    /** @summary Get Metric Definitions */
    ensureInfiniteQueryData<
      TPageParam extends GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters,
    >(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
        GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
        GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters,
        DeepReadonly<TPageParam>,
        GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
        GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters
      >
    >;
    /** @summary Get Metric Definitions */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters
          >
        | DeepReadonly<GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters>
    ): GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData | undefined;
    /** @summary Get Metric Definitions */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters
          >
        | DeepReadonly<GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters>
    ):
      | OperationInfiniteData<
          GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
          GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters
        >
      | undefined;
    /** @summary Get Metric Definitions */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
            TInfinite,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError
          >
        | QueryFiltersByQueryKey<
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
            TInfinite,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
              GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
                    GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
              GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters
            >,
            data: GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData | undefined,
          ]
        >;
    /** @summary Get Metric Definitions */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters
          >
        | DeepReadonly<GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters>
    ):
      | QueryState<
          GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
          GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError
        >
      | undefined;
    /** @summary Get Metric Definitions */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters
          >,
          GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError
        >
      | undefined;
    /** @summary Get Metric Definitions */
    setQueryData(
      parameters:
        | DeepReadonly<GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters>
        | ServiceOperationQueryKey<
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters
          >,
      updater: Updater<
        NoInfer<GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData> | undefined,
        NoInfer<DeepReadonly<GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData | undefined;
    /** @summary Get Metric Definitions */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
              GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
                GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
          GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters
        >
      | undefined;
    /** @summary Get Metric Definitions */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
            TInfinite,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError
          >
        | QueryFiltersByQueryKey<
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
            TInfinite,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError
          >,
      updater: Updater<
        NoInfer<GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData> | undefined,
        NoInfer<GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData | undefined>;
    /** @summary Get Metric Definitions */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
        GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
        TInfinite,
        GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters,
        GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Get Metric Definitions */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
            TInfinite,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError
          >
        | QueryFiltersByQueryKey<
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
            TInfinite,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Get Metric Definitions */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
            TInfinite,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError
          >
        | QueryFiltersByQueryKey<
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
            TInfinite,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Get Metric Definitions */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
            TInfinite,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError
          >
        | QueryFiltersByQueryKey<
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
            TInfinite,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError
          >
    ): void;
    /** @summary Get Metric Definitions */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
            TInfinite,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError
          >
        | QueryFiltersByQueryKey<
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
            TInfinite,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Get Metric Definitions */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
            TInfinite,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError
          >
        | QueryFiltersByQueryKey<
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData,
            TInfinite,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters,
            GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError
          >
    ): number;
    schema: GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema;
    types: {
      parameters: GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters;
      data: GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData;
      error: GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError;
    };
  };
  /** @summary Update */
  updateExternalCallsMetricDefinitionsDefinitionKeyPut: {
    /** @summary Update */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        UpdateExternalCallsMetricDefinitionsDefinitionKeyPutBody,
        UpdateExternalCallsMetricDefinitionsDefinitionKeyPutParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: UpdateExternalCallsMetricDefinitionsDefinitionKeyPutSchema,
        options: ServiceOperationMutationFnOptions<
          UpdateExternalCallsMetricDefinitionsDefinitionKeyPutBody,
          UpdateExternalCallsMetricDefinitionsDefinitionKeyPutParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          UpdateExternalCallsMetricDefinitionsDefinitionKeyPutData,
          UpdateExternalCallsMetricDefinitionsDefinitionKeyPutError
        >
      >
    ): Promise<
      RequestFnResponse<
        UpdateExternalCallsMetricDefinitionsDefinitionKeyPutData,
        UpdateExternalCallsMetricDefinitionsDefinitionKeyPutError
      >
    >;
    /** @summary Update */
    getMutationKey(
      parameters: DeepReadonly<UpdateExternalCallsMetricDefinitionsDefinitionKeyPutParameters> | void
    ): ServiceOperationMutationKey<
      UpdateExternalCallsMetricDefinitionsDefinitionKeyPutSchema,
      UpdateExternalCallsMetricDefinitionsDefinitionKeyPutParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.metricsService.updateExternalCallsMetricDefinitionsDefinitionKeyPut.useMutation({
     *     path: {
     *         definition_key: definitionKey
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.metricsService.updateExternalCallsMetricDefinitionsDefinitionKeyPut.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         definition_key: definitionKey
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends UpdateExternalCallsMetricDefinitionsDefinitionKeyPutBody, TContext = unknown>(
      parameters: DeepReadonly<UpdateExternalCallsMetricDefinitionsDefinitionKeyPutParameters>,
      options?: ServiceOperationUseMutationOptions<
        UpdateExternalCallsMetricDefinitionsDefinitionKeyPutSchema,
        UpdateExternalCallsMetricDefinitionsDefinitionKeyPutData,
        UpdateExternalCallsMetricDefinitionsDefinitionKeyPutParameters,
        TVariables,
        OperationError<UpdateExternalCallsMetricDefinitionsDefinitionKeyPutError>,
        TContext
      >
    ): UseMutationResult<
      UpdateExternalCallsMetricDefinitionsDefinitionKeyPutData,
      OperationError<UpdateExternalCallsMetricDefinitionsDefinitionKeyPutError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.metricsService.updateExternalCallsMetricDefinitionsDefinitionKeyPut.useMutation({
     *     path: {
     *         definition_key: definitionKey
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.metricsService.updateExternalCallsMetricDefinitionsDefinitionKeyPut.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         definition_key: definitionKey
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        UpdateExternalCallsMetricDefinitionsDefinitionKeyPutBody,
        UpdateExternalCallsMetricDefinitionsDefinitionKeyPutParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UpdateExternalCallsMetricDefinitionsDefinitionKeyPutSchema,
        UpdateExternalCallsMetricDefinitionsDefinitionKeyPutData,
        UpdateExternalCallsMetricDefinitionsDefinitionKeyPutParameters,
        TVariables,
        OperationError<UpdateExternalCallsMetricDefinitionsDefinitionKeyPutError>,
        TContext
      >
    ): UseMutationResult<
      UpdateExternalCallsMetricDefinitionsDefinitionKeyPutData,
      OperationError<UpdateExternalCallsMetricDefinitionsDefinitionKeyPutError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const updateExternalCallsMetricDefinitionsDefinitionKeyPutTotal = qraft.metricsService.updateExternalCallsMetricDefinitionsDefinitionKeyPut.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const updateExternalCallsMetricDefinitionsDefinitionKeyPutTotal = qraft.metricsService.updateExternalCallsMetricDefinitionsDefinitionKeyPut.useIsMutating({
     *     parameters: {
     *         path: {
     *             definition_key: definitionKey
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UpdateExternalCallsMetricDefinitionsDefinitionKeyPutBody,
            UpdateExternalCallsMetricDefinitionsDefinitionKeyPutData,
            UpdateExternalCallsMetricDefinitionsDefinitionKeyPutParameters,
            OperationError<UpdateExternalCallsMetricDefinitionsDefinitionKeyPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateExternalCallsMetricDefinitionsDefinitionKeyPutSchema,
            UpdateExternalCallsMetricDefinitionsDefinitionKeyPutBody,
            UpdateExternalCallsMetricDefinitionsDefinitionKeyPutData,
            UpdateExternalCallsMetricDefinitionsDefinitionKeyPutParameters,
            OperationError<UpdateExternalCallsMetricDefinitionsDefinitionKeyPutError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const updateExternalCallsMetricDefinitionsDefinitionKeyPutPendingMutationVariables = qraft.metricsService.updateExternalCallsMetricDefinitionsDefinitionKeyPut.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const updateExternalCallsMetricDefinitionsDefinitionKeyPutMutationData = qraft.metricsService.updateExternalCallsMetricDefinitionsDefinitionKeyPut.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 definition_key: definitionKey
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UpdateExternalCallsMetricDefinitionsDefinitionKeyPutData,
        OperationError<UpdateExternalCallsMetricDefinitionsDefinitionKeyPutError>,
        MutationVariables<
          UpdateExternalCallsMetricDefinitionsDefinitionKeyPutBody,
          UpdateExternalCallsMetricDefinitionsDefinitionKeyPutParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UpdateExternalCallsMetricDefinitionsDefinitionKeyPutBody,
            UpdateExternalCallsMetricDefinitionsDefinitionKeyPutData,
            UpdateExternalCallsMetricDefinitionsDefinitionKeyPutParameters,
            OperationError<UpdateExternalCallsMetricDefinitionsDefinitionKeyPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateExternalCallsMetricDefinitionsDefinitionKeyPutSchema,
            UpdateExternalCallsMetricDefinitionsDefinitionKeyPutBody,
            UpdateExternalCallsMetricDefinitionsDefinitionKeyPutData,
            UpdateExternalCallsMetricDefinitionsDefinitionKeyPutParameters,
            OperationError<UpdateExternalCallsMetricDefinitionsDefinitionKeyPutError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UpdateExternalCallsMetricDefinitionsDefinitionKeyPutData,
          OperationError<UpdateExternalCallsMetricDefinitionsDefinitionKeyPutError>,
          MutationVariables<
            UpdateExternalCallsMetricDefinitionsDefinitionKeyPutBody,
            UpdateExternalCallsMetricDefinitionsDefinitionKeyPutParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Update */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UpdateExternalCallsMetricDefinitionsDefinitionKeyPutBody,
            UpdateExternalCallsMetricDefinitionsDefinitionKeyPutData,
            UpdateExternalCallsMetricDefinitionsDefinitionKeyPutParameters,
            OperationError<UpdateExternalCallsMetricDefinitionsDefinitionKeyPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateExternalCallsMetricDefinitionsDefinitionKeyPutSchema,
            UpdateExternalCallsMetricDefinitionsDefinitionKeyPutBody,
            UpdateExternalCallsMetricDefinitionsDefinitionKeyPutData,
            UpdateExternalCallsMetricDefinitionsDefinitionKeyPutParameters,
            OperationError<UpdateExternalCallsMetricDefinitionsDefinitionKeyPutError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.metricsService.updateExternalCallsMetricDefinitionsDefinitionKeyPut.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             definition_key: definitionKey
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.metricsService.updateExternalCallsMetricDefinitionsDefinitionKeyPut.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UpdateExternalCallsMetricDefinitionsDefinitionKeyPutBody,
              UpdateExternalCallsMetricDefinitionsDefinitionKeyPutData,
              UpdateExternalCallsMetricDefinitionsDefinitionKeyPutParameters,
              OperationError<UpdateExternalCallsMetricDefinitionsDefinitionKeyPutError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateExternalCallsMetricDefinitionsDefinitionKeyPutSchema,
              UpdateExternalCallsMetricDefinitionsDefinitionKeyPutBody,
              UpdateExternalCallsMetricDefinitionsDefinitionKeyPutData,
              UpdateExternalCallsMetricDefinitionsDefinitionKeyPutParameters,
              OperationError<UpdateExternalCallsMetricDefinitionsDefinitionKeyPutError>,
              TContext
            >
      ):
        | Mutation<
            UpdateExternalCallsMetricDefinitionsDefinitionKeyPutData,
            UpdateExternalCallsMetricDefinitionsDefinitionKeyPutError,
            MutationVariables<
              UpdateExternalCallsMetricDefinitionsDefinitionKeyPutBody,
              UpdateExternalCallsMetricDefinitionsDefinitionKeyPutParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UpdateExternalCallsMetricDefinitionsDefinitionKeyPutBody,
              UpdateExternalCallsMetricDefinitionsDefinitionKeyPutData,
              UpdateExternalCallsMetricDefinitionsDefinitionKeyPutParameters,
              OperationError<UpdateExternalCallsMetricDefinitionsDefinitionKeyPutError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateExternalCallsMetricDefinitionsDefinitionKeyPutSchema,
              UpdateExternalCallsMetricDefinitionsDefinitionKeyPutBody,
              UpdateExternalCallsMetricDefinitionsDefinitionKeyPutData,
              UpdateExternalCallsMetricDefinitionsDefinitionKeyPutParameters,
              OperationError<UpdateExternalCallsMetricDefinitionsDefinitionKeyPutError>,
              TContext
            >
      ): Array<
        Mutation<
          UpdateExternalCallsMetricDefinitionsDefinitionKeyPutData,
          UpdateExternalCallsMetricDefinitionsDefinitionKeyPutError,
          MutationVariables<
            UpdateExternalCallsMetricDefinitionsDefinitionKeyPutBody,
            UpdateExternalCallsMetricDefinitionsDefinitionKeyPutParameters
          >,
          TContext
        >
      >;
    };
    schema: UpdateExternalCallsMetricDefinitionsDefinitionKeyPutSchema;
    types: {
      parameters: UpdateExternalCallsMetricDefinitionsDefinitionKeyPutParameters;
      data: UpdateExternalCallsMetricDefinitionsDefinitionKeyPutData;
      error: UpdateExternalCallsMetricDefinitionsDefinitionKeyPutError;
      body: UpdateExternalCallsMetricDefinitionsDefinitionKeyPutBody;
    };
  };
  /** @summary Delete */
  deleteExternalCallsMetricDefinitionsDefinitionKeyDelete: {
    /** @summary Delete */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteBody,
        DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteSchema,
        options: ServiceOperationMutationFnOptions<
          DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteBody,
          DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteData,
          DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteError
        >
      >
    ): Promise<
      RequestFnResponse<
        DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteData,
        DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteError
      >
    >;
    /** @summary Delete */
    getMutationKey(
      parameters: DeepReadonly<DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteParameters> | void
    ): ServiceOperationMutationKey<
      DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteSchema,
      DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Delete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.metricsService.deleteExternalCallsMetricDefinitionsDefinitionKeyDelete.useMutation({
     *     path: {
     *         definition_key: definitionKey
     *     },
     *     query: {
     *         team_id: teamId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.metricsService.deleteExternalCallsMetricDefinitionsDefinitionKeyDelete.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         definition_key: definitionKey
     *     },
     *     query: {
     *         team_id: teamId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteBody, TContext = unknown>(
      parameters: DeepReadonly<DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteParameters>,
      options?: ServiceOperationUseMutationOptions<
        DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteSchema,
        DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteData,
        DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteParameters,
        TVariables,
        OperationError<DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteError>,
        TContext
      >
    ): UseMutationResult<
      DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteData,
      OperationError<DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteError>,
      TVariables | void,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Delete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.metricsService.deleteExternalCallsMetricDefinitionsDefinitionKeyDelete.useMutation({
     *     path: {
     *         definition_key: definitionKey
     *     },
     *     query: {
     *         team_id: teamId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.metricsService.deleteExternalCallsMetricDefinitionsDefinitionKeyDelete.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         definition_key: definitionKey
     *     },
     *     query: {
     *         team_id: teamId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteBody,
        DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteSchema,
        DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteData,
        DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteParameters,
        TVariables,
        OperationError<DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteError>,
        TContext
      >
    ): UseMutationResult<
      DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteData,
      OperationError<DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Delete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const deleteExternalCallsMetricDefinitionsDefinitionKeyDeleteTotal = qraft.metricsService.deleteExternalCallsMetricDefinitionsDefinitionKeyDelete.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const deleteExternalCallsMetricDefinitionsDefinitionKeyDeleteTotal = qraft.metricsService.deleteExternalCallsMetricDefinitionsDefinitionKeyDelete.useIsMutating({
     *     parameters: {
     *         path: {
     *             definition_key: definitionKey
     *         },
     *         query: {
     *             team_id: teamId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteBody,
            DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteData,
            DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteParameters,
            OperationError<DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteSchema,
            DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteBody,
            DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteData,
            DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteParameters,
            OperationError<DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Delete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const deleteExternalCallsMetricDefinitionsDefinitionKeyDeletePendingMutationVariables = qraft.metricsService.deleteExternalCallsMetricDefinitionsDefinitionKeyDelete.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const deleteExternalCallsMetricDefinitionsDefinitionKeyDeleteMutationData = qraft.metricsService.deleteExternalCallsMetricDefinitionsDefinitionKeyDelete.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 definition_key: definitionKey
     *             },
     *             query: {
     *                 team_id: teamId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteData,
        OperationError<DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteError>,
        MutationVariables<
          DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteBody,
          DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteBody,
            DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteData,
            DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteParameters,
            OperationError<DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteSchema,
            DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteBody,
            DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteData,
            DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteParameters,
            OperationError<DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteData,
          OperationError<DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteError>,
          MutationVariables<
            DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteBody,
            DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Delete */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteBody,
            DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteData,
            DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteParameters,
            OperationError<DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteSchema,
            DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteBody,
            DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteData,
            DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteParameters,
            OperationError<DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Delete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.metricsService.deleteExternalCallsMetricDefinitionsDefinitionKeyDelete.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             definition_key: definitionKey
     *         },
     *         query: {
     *             team_id: teamId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.metricsService.deleteExternalCallsMetricDefinitionsDefinitionKeyDelete.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteBody,
              DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteData,
              DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteParameters,
              OperationError<DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteSchema,
              DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteBody,
              DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteData,
              DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteParameters,
              OperationError<DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteError>,
              TContext
            >
      ):
        | Mutation<
            DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteData,
            DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteError,
            MutationVariables<
              DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteBody,
              DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteBody,
              DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteData,
              DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteParameters,
              OperationError<DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteSchema,
              DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteBody,
              DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteData,
              DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteParameters,
              OperationError<DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteError>,
              TContext
            >
      ): Array<
        Mutation<
          DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteData,
          DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteError,
          MutationVariables<
            DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteBody,
            DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteParameters
          >,
          TContext
        >
      >;
    };
    schema: DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteSchema;
    types: {
      parameters: DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteParameters;
      data: DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteData;
      error: DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteError;
      body: DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteBody;
    };
  };
}
/** @summary List Metric Metrics */
export const listMetricMetricsExternalCallsMetricDefinitionsGet = {
  schema: {
    method: 'get',
    url: '/external_calls/metric_definitions/',
    security: ['HTTPBearer'],
  },
} as {
  schema: ListMetricMetricsExternalCallsMetricDefinitionsGetSchema;
  [QraftServiceOperationsToken]: MetricsService['listMetricMetricsExternalCallsMetricDefinitionsGet'];
};
/** @summary Create */
export const createExternalCallsMetricDefinitionsPost = {
  schema: {
    method: 'post',
    url: '/external_calls/metric_definitions/',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: CreateExternalCallsMetricDefinitionsPostSchema;
  [QraftServiceOperationsToken]: MetricsService['createExternalCallsMetricDefinitionsPost'];
};
/** @summary Get Metric Definitions */
export const getMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGet = {
  schema: {
    method: 'get',
    url: '/external_calls/metric_definitions/{definition_key}',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema;
  [QraftServiceOperationsToken]: MetricsService['getMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGet'];
};
/** @summary Update */
export const updateExternalCallsMetricDefinitionsDefinitionKeyPut = {
  schema: {
    method: 'put',
    url: '/external_calls/metric_definitions/{definition_key}',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: UpdateExternalCallsMetricDefinitionsDefinitionKeyPutSchema;
  [QraftServiceOperationsToken]: MetricsService['updateExternalCallsMetricDefinitionsDefinitionKeyPut'];
};
/** @summary Delete */
export const deleteExternalCallsMetricDefinitionsDefinitionKeyDelete = {
  schema: {
    method: 'delete',
    url: '/external_calls/metric_definitions/{definition_key}',
    security: ['HTTPBearer'],
  },
} as {
  schema: DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteSchema;
  [QraftServiceOperationsToken]: MetricsService['deleteExternalCallsMetricDefinitionsDefinitionKeyDelete'];
};
export const metricsService = {
  listMetricMetricsExternalCallsMetricDefinitionsGet,
  createExternalCallsMetricDefinitionsPost,
  getMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGet,
  updateExternalCallsMetricDefinitionsDefinitionKeyPut,
  deleteExternalCallsMetricDefinitionsDefinitionKeyDelete,
} as const;
type ListMetricMetricsExternalCallsMetricDefinitionsGetSchema = {
  method: 'get';
  url: '/external_calls/metric_definitions/';
  security: ['HTTPBearer'];
};
type ListMetricMetricsExternalCallsMetricDefinitionsGetParameters =
  paths['/external_calls/metric_definitions/']['get']['parameters'];
type ListMetricMetricsExternalCallsMetricDefinitionsGetData =
  paths['/external_calls/metric_definitions/']['get']['responses']['200']['content']['application/json'];
type ListMetricMetricsExternalCallsMetricDefinitionsGetError =
  paths['/external_calls/metric_definitions/']['get']['responses']['422']['content']['application/json'];
type CreateExternalCallsMetricDefinitionsPostSchema = {
  method: 'post';
  url: '/external_calls/metric_definitions/';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type CreateExternalCallsMetricDefinitionsPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateExternalCallsMetricDefinitionsPostData =
  paths['/external_calls/metric_definitions/']['post']['responses']['200']['content']['application/json'];
type CreateExternalCallsMetricDefinitionsPostError =
  paths['/external_calls/metric_definitions/']['post']['responses']['422']['content']['application/json'];
type CreateExternalCallsMetricDefinitionsPostBody =
  paths['/external_calls/metric_definitions/']['post']['requestBody']['content']['application/json'];
type GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetSchema = {
  method: 'get';
  url: '/external_calls/metric_definitions/{definition_key}';
  security: ['HTTPBearer'];
};
type GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetParameters =
  paths['/external_calls/metric_definitions/{definition_key}']['get']['parameters'];
type GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetData =
  paths['/external_calls/metric_definitions/{definition_key}']['get']['responses']['200']['content']['application/json'];
type GetMetricDefinitionsExternalCallsMetricDefinitionsDefinitionKeyGetError =
  paths['/external_calls/metric_definitions/{definition_key}']['get']['responses']['422']['content']['application/json'];
type UpdateExternalCallsMetricDefinitionsDefinitionKeyPutSchema = {
  method: 'put';
  url: '/external_calls/metric_definitions/{definition_key}';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type UpdateExternalCallsMetricDefinitionsDefinitionKeyPutParameters =
  paths['/external_calls/metric_definitions/{definition_key}']['put']['parameters'];
type UpdateExternalCallsMetricDefinitionsDefinitionKeyPutData =
  paths['/external_calls/metric_definitions/{definition_key}']['put']['responses']['200']['content']['application/json'];
type UpdateExternalCallsMetricDefinitionsDefinitionKeyPutError =
  paths['/external_calls/metric_definitions/{definition_key}']['put']['responses']['422']['content']['application/json'];
type UpdateExternalCallsMetricDefinitionsDefinitionKeyPutBody =
  paths['/external_calls/metric_definitions/{definition_key}']['put']['requestBody']['content']['application/json'];
type DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteSchema = {
  method: 'delete';
  url: '/external_calls/metric_definitions/{definition_key}';
  security: ['HTTPBearer'];
};
type DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteParameters =
  paths['/external_calls/metric_definitions/{definition_key}']['delete']['parameters'];
type DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteData =
  paths['/external_calls/metric_definitions/{definition_key}']['delete']['responses']['200']['content']['application/json'];
type DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteError =
  paths['/external_calls/metric_definitions/{definition_key}']['delete']['responses']['422']['content']['application/json'];
type DeleteExternalCallsMetricDefinitionsDefinitionKeyDeleteBody = undefined;
